module.exports = __webpack_public_path__ + "img/malattia4.e5caa1d9.png";